var XPortal = XPortal || {};
XPortal.SchedulerEditor = (function () {
    var self = {
        ControlSelector: ".data-xscheduler, .data-xscheduler-readonly",
        Init: function (container) {
            container = container ? container : $(XPortal.Main.DetialFormSelector);
            container.find(XPortal.SchedulerEditor.ControlSelector).each(function (ip, element) {
                XPortal.SchedulerEditor.initFor(XPortal.Store.getModelName(container[0].id), element);
            });
        },
        GetValue: function (el) {

        },
        SetValue: function (el, val) {

        },
        initFor: function (modelName, element) {
            element = $(element);
            const sttgs = XPortal.Main.GetSettingsFor(element);
            const srvOpts = $.extend(JSON.parse(element.attr("data-model-options")), JSON.parse(element.attr("data-model-eoptions")));
            const sSttgs = $.extend(true, {}, sttgs, { meta: { fieldname: srvOpts.startField } });
            const eSttgs = $.extend(true, {}, sttgs, { meta: { fieldname: srvOpts.endField } });
            let stepSlot = srvOpts.xStepSlot ? srvOpts.xStepSlot : 15;

            const coptions = $.extend(true, srvOpts, {
                kendoScheduller: {
                    selectable: true, editable: false, minorTickCount: 1, majorTick: stepSlot,
                    change: function (e) {
                        var x1 = e.start;
                        var x2 = e.end;
                        if (x1 >= x2) { x2 = e.start; x1 = e.end; }
                        sSttgs.value = e.start === null ? '' : XPortal.Utils.customISOstring(x1, x1.getTimezoneOffset());
                        eSttgs.value = e.end === null ? '' : XPortal.Utils.customISOstring(x2, x2.getTimezoneOffset());
                        XPortal.DefaultEditor.SetModification(element, sSttgs.value + "|" + eSttgs.value);
                        clearTimeout(sSttgs.itimeout);
                        sSttgs.itimeout = setTimeout(function () {
                            XPortal.Store.FieldEvent(element, sSttgs.value, modelName, sSttgs);
                            XPortal.Store.FieldEvent(element, eSttgs.value, modelName, eSttgs);
                        }, 250);
                    }
                }, onXNavigate: function (e, cobj) {
                    setTimeout(function () {
                        resizeRows($('#calendar-' + coptions.calendarId));
                    }, 300);
                }
            });
            const setSelection = function (el, startDate, endDate) {
                var kscheduler = $('#calendar-' + coptions.calendarId).data("kendoScheduler");
                if (!kscheduler) return;
                var curSel = kscheduler.select();
                kscheduler.select({ id: 1, start: moment(startDate).toDate(), end: moment(endDate).toDate(), title: "Interview" });
            };
            const resizeRows = function (cobj) {
                var widget = $(cobj).data('kendoScheduler');
                var resizeRows = coptions.xRowHeight > 0;
                if (resizeRows) {
                    cobj.find(".k-scheduler-table").find("td, th").each(function () {
                        var xrs = Number($(this).attr("rowspan"));
                        if (isNaN(xrs)) xrs = 1;
                        $(this).height(coptions.xRowHeight * xrs);
                        $(this).css('overflow', 'hidden');
                    });
                }
                if(widget) {
                    widget.resize(true);
                    widget.refresh();
                }
            };
            XPortal.Calendar.Init('#calendar-' + coptions.calendarId, coptions).then(resizeRows($('#calendar-' + coptions.calendarId)));
        }
    };
    return self;
}());
